import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import { useEffect } from 'react'

export default function RichTextEditor({ value, onChange, placeholder }) {
  const editor = useEditor({
    extensions: [StarterKit, Underline],
    content: value || '',
    onUpdate: ({ editor }) => {
      onChange(editor.getHTML())
    },
  })

  useEffect(() => {
    if (editor && value === '') {
      editor.commands.setContent('')
    }
  }, [value, editor])

  if (!editor) return null

  return (
    <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
      <div style={{
        display: 'flex', gap: '4px', padding: '8px',
        borderBottom: '1px solid #e2e8f0', backgroundColor: '#f8fafc', flexWrap: 'wrap'
      }}>
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleBold().run()}
          active={editor.isActive('bold')}
          title="Gras"
        ><strong>G</strong></ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleItalic().run()}
          active={editor.isActive('italic')}
          title="Italique"
        ><em>I</em></ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleUnderline().run()}
          active={editor.isActive('underline')}
          title="Souligné"
        ><u>S</u></ToolbarButton>
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
          active={editor.isActive('heading', { level: 2 })}
          title="Titre"
        >T</ToolbarButton>
      </div>

      <EditorContent
        editor={editor}
        style={{ padding: '12px', minHeight: '120px', fontSize: '14px', lineHeight: '1.6' }}
      />

      <style>{`
        .tiptap p.is-editor-empty:first-child::before {
          content: "${placeholder || 'Saisir le texte...'}";
          color: #adb5bd;
          pointer-events: none;
          float: left;
          height: 0;
        }
      `}</style>
    </div>
  )
}

function ToolbarButton({ onClick, active, title, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      style={{
        padding: '4px 10px', borderRadius: '4px', border: '1px solid #e2e8f0',
        backgroundColor: active ? '#667eea' : '#fff',
        color: active ? '#fff' : '#374151',
        cursor: 'pointer', fontSize: '13px', fontWeight: '600'
      }}
    >
      {children}
    </button>
  )
}